import { createReducer, on } from '@ngrx/store';
import * as NotificationActions from '../actions/notification.actions';
import { MyNotification } from '@models/my-notification';

export const notificationFeatureKey = 'notification';

export interface AuthPartialState {
  readonly [notificationFeatureKey]: MyNotification;
}

export const initialState: MyNotification = {
  show: false,
  success: false,
  error: false,
  title: '',
  timer: false,
  message: '',
  image: '',
  className: '',
  animation: ''
};

export const notificationReducer = createReducer(initialState,
  on(NotificationActions.setNotification, (state, { message }) => {
    return {
      ...state,
      show: true, success: false, error: false,
      message,
      title: 'notification.alert'
    };
  }),
  on(NotificationActions.setSuccess, (state, { message }) => {
    return {
      ...state,
      show: true, success: true, error: false,
      message,
      title: 'notification.success'
    };
  }),
  on(NotificationActions.setError, (state, { message }) => {
    return {
      ...state,
      show: true, success: false, error: true,
      message: message,
      title: 'notification.error'
    };
  }),
  on(NotificationActions.closeNotification, state => {
    return {
      ...state,
      show: false, success: false, error: false,
      message: '', title: ''
    };
  })
);
